"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckmarkLargeIcon = void 0;
var react_1 = __importDefault(require("react"));
var build_svg_icon_1 = require("./build-svg-icon");
exports.CheckmarkLargeIcon = (0, build_svg_icon_1.buildSvgIcon)(react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.7071 6.29289C21.0976 6.68342 21.0976 7.31658 20.7071 7.70711L10.7071 17.7071C10.3166 18.0976 9.68342 18.0976 9.29289 17.7071L4.29289 12.7071C3.90237 12.3166 3.90237 11.6834 4.29289 11.2929C4.68342 10.9024 5.31658 10.9024 5.70711 11.2929L10 15.5858L19.2929 6.29289C19.6834 5.90237 20.3166 5.90237 20.7071 6.29289Z" }), 'BannerCheckmarkIcon');
exports.default = exports.CheckmarkLargeIcon;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2hlY2ttYXJrTGFyZ2VJY29uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vaWNvbnMvQ2hlY2ttYXJrTGFyZ2VJY29uLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxnREFBMEI7QUFDMUIsbURBQWdEO0FBRW5DLFFBQUEsa0JBQWtCLEdBQUcsSUFBQSw2QkFBWSxFQUM1Qyx3Q0FDRSxRQUFRLEVBQUMsU0FBUyxFQUNsQixRQUFRLEVBQUMsU0FBUyxFQUNsQixDQUFDLEVBQUMsOFRBQThULEdBQ2hVLEVBQ0YscUJBQXFCLENBQ3RCLENBQUM7QUFFRixrQkFBZSwwQkFBa0IsQ0FBQyJ9


//////////////////
// WEBPACK FOOTER
// ./node_modules/@angi/icons/icons/CheckmarkLargeIcon.js
// module id = 3521
// module chunks = 25